define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var copyrightFormWrapper = $('#copyright-form-wrapper');
    var fileUidsInput = copyrightFormWrapper.find('.input-file-uids');
    var fileElements = $('img[data-has-copyright]');
    var fileIds = [];
    fileElements.each(function () {
        fileIds.push($(this).data('file-id'));
    });
    if (fileIds.length > 0) {
        copyrightFormWrapper.show();
    }
    fileUidsInput.val(fileIds);
    copyrightFormWrapper.find('.submit-link').click(function (event) {
        event.preventDefault();
        copyrightFormWrapper.find('form').submit();
    });
});
